import { Injectable } from '@angular/core';
import { UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { UigLegalAdapter } from './uig-legal.adapter';
import { TermsAndConditionsResponse } from './uig-legal.model';

@Injectable({
  providedIn: 'root',
})
export class UigLegalService {

  constructor(
    protected uigLegalAdapter: UigLegalAdapter,
    protected userIdService: UserIdService
  ) {}

  termsAndConditionsAccept(): Observable<TermsAndConditionsResponse> {
    let userId;
    this.userIdService
      .getUserId()
      .subscribe((occUserId) => (userId = occUserId))
      .unsubscribe();

    return this.uigLegalAdapter
      .termsAndConditionsAccept(userId);
  }

  termsAndConditionsDecline(): Observable<TermsAndConditionsResponse> {
    let userId;
    this.userIdService
      .getUserId()
      .subscribe((occUserId) => (userId = occUserId))
      .unsubscribe();

    return this.uigLegalAdapter
      .termsAndConditionsDecline(userId);
  }
}
